import { FormsTableStatus } from 'app-constants';
import { DeleteDraftForm } from '../../../DeleteDraftForm';

export const DeleteFormButton = (props) => {
  const {
    formDetails,
    refetchForms,
    disableSections,
    selectedFormStatus,
    selectedFormProcess,
    onDeleteFormSuccess,
  } = props;

  const isDraftForm = selectedFormStatus === FormsTableStatus.Draft;

  const isFormCreator = formDetails?.isOwner;

  if (!isDraftForm || !isFormCreator) return null;

  return (
    <DeleteDraftForm
      formName={formDetails?.formName}
      formProcessId={selectedFormProcess}
      onDeleteFormSuccess={onDeleteFormSuccess}
      refetchForms={refetchForms}
      disableSections={disableSections}
    />
  );
};
